module.exports = __webpack_public_path__ + "3b4ed766f0ba114194ce411a33d3852f.svg";